import { ReactNode, PropsWithChildren } from "react";
import { alpha, useTheme } from "@mui/material/styles";
import { Divider, Drawer, IconButton, Stack, Typography, Grid } from "@mui/material";
import { bgBlur } from "utils/cssStyles";
import Scrollbar from "components/scrollbar";
import { CUSTOM_DRAWER_CONFIG } from "configs/app.config";
import Iconify from "components/iconify";

const SPACING = 2.5;

export interface CustomDrawerProps extends PropsWithChildren {
  open: boolean;
  onClose: VoidFunction;
  heading: string;
  headingComponent?: ReactNode;
  width?: number | string;
}

export default function CustomDrawer({
  open,
  onClose,
  heading,
  headingComponent,
  width,
  children,
}: CustomDrawerProps) {
  const theme = useTheme();

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        BackdropProps={{ invisible: true }}
        PaperProps={{
          sx: {
            ...bgBlur({ color: theme.palette.background.default, opacity: 0.9 }),
            width: width ? width : CUSTOM_DRAWER_CONFIG.BASE_WIDTH,
            boxShadow: `-24px 12px 40px 0 ${alpha(
              theme.palette.mode === "light" ? theme.palette.grey[500] : theme.palette.common.black,
              0.16
            )}`,
            //it should be dynamic
            backgroundColor:'#F4F6F8'
          },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ py: 2, pr: 1, pl: SPACING,backgroundColor:'#FFFFFF' }}
        >
          <Typography variant="subtitle1" sx={{ flexGrow: 0 }}>
            {heading}
          </Typography>
          {headingComponent && <Grid sx={{ flexGrow: 1, pl: SPACING }}>{headingComponent}</Grid>}
        </Stack>

        <IconButton
          aria-label="close"
          size="small"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 15,
            color: (theme) => theme.palette.text.primary,
          }}
        >
          <Iconify icon="mdi:close" width={16} height={16} />
        </IconButton>
        <Divider />
        
        <Scrollbar sx={{ p: "24px", pb: 0 }}>{children}</Scrollbar>
      </Drawer>
    </>
  );
}
